module.exports = __webpack_public_path__ + "img/9.0e517c9a.png";